import script from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenSelectInput.vue?vue&type=style&index=0&id=5098ec14&scoped=true&lang=css"
script.__scopeId = "data-v-5098ec14"

export default script